const __request = require(`../__request/__request_contentType_json`);

// 国内退款列表
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/buyer/dom/manage/reimburseList',
    data:data
  }

  return __request(pParameter)
}

